import { useMemo } from 'react'
import CollectionRunsheetsView from '@components/collection/Collection/CollectionRunsheetsView'
import { Mosaic } from 'react-mosaic-component'
import CircleSpinner from '@components/shared/CircleSpinner'
import { Documents } from '@components/collection/Documents'

/**
 * 
 * @param {CollectionViewModel} vm
 * @param {UUID} collectionId
 * @returns {JSX.Element}
 * @constructor
 */
const CollectionBrowseView = ({
    vm,
    collectionId,
}) => {
    
    const showLoading = useMemo(() => (
        !collectionId ||
        !vm.currentCollection ||
        vm.currentCollection.id !== collectionId
    ), [collectionId, vm.currentCollection])
    
    return (
        
        <div>
            
            {vm.error && (
                <div className="CollectionDetail">
                    <div className="absolute absolute-centered">
                        {vm.error}
                    </div>
                </div>
            )}
            
            {(!vm.error && showLoading) && (
                <div className="CollectionDetail">
                    <CircleSpinner className="absolute-centered" />
                </div>
            )}
            
            {!vm.error && !showLoading && (
                <Mosaic
                    className="CollectionBrowseView parse-mosaic"
                    style={{ height: 'calc(100vh - 135px)' }}
                    renderTile={id => ({
                        docs: (
                            <Documents
                                collectionId={collectionId}
                                deleteDocument={vm.setShowDeleteDocument}
                                editDocument={vm.setShowEditDocument}
                                getDocumentName={vm.setDocumentName}
                                setDocumentInfo={vm.setDocumentInfo}
                                markedDocuments={vm.markedDocuments}
                                setMarkedDocuments={vm.setMarkedDocuments}
                                openRunsheetId={vm.searchParams.get('openRunsheetId')}/>
                        ),
                        runsheets: vm.selectedRunsheet && <CollectionRunsheetsView vm={vm} />,
                    })[id]}
                    resize={!vm.selectedRunsheet ? 'DISABLED' : { minimumPaneSizePercentage: 1 }}
                    initialValue={{
                        direction: 'column',
                        first: 'docs',
                        second: 'runsheets',
                        splitPercentage: vm.selectedRunsheet ? 50 : 100,
                    }} />
            )}
        
        </div>
        
    )
    
}

export default CollectionBrowseView
